import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_SETTINGS_STATE } from '../../../constants/createSendSettings';
import { ICreateSendSettingsState } from '../../../types/createSendSettings';
import * as AuthActions from '../../actions/auth';
import * as SendSettingsActions from '../actions/sendSettings';

export const initialState: ICreateSendSettingsState = DEFAULT_CREATE_SEND_SETTINGS_STATE;

const reducer = (state: ICreateSendSettingsState = initialState, action: any): ICreateSendSettingsState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT: {
      return initialState;
    }
    case SendSettingsActions.PATCH_CS_SEND_SETTINGS: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

export default reducer;
